module.exports = __webpack_public_path__ + "img/yat@2x.8acc3260.png";